export { GeneralInfo, DEFAULT_GENERAL_INFO } from "./GeneralInfo";
